import { render } from "./pull_back_return_approval.vue?vue&type=template&id=067b9267&scoped=true"
import script from "./pull_back_return_approval.vue?vue&type=script&lang=js"
export * from "./pull_back_return_approval.vue?vue&type=script&lang=js"

import "./pull_back_return_approval.vue?vue&type=style&index=0&id=067b9267&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-067b9267"]])

export default __exports__